import React from 'react';
import "./Styles/Calculators.css";
import "./Styles/UserWelcome.css";
import NavBar from '../NavBar';
import MetabolicSyndromeCalculator from './Components/CalculatorPages/CalculatorMetabolic';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function MetabolicSyndromeCalculatorRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileMetabolicRoutePage">
                    <div className="UserProfileMetabolicRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="MetabolicSyndromeCalculatorRouteBlock">
                        <MetabolicSyndromeCalculator/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default MetabolicSyndromeCalculatorRoute;